var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.0672C22.5 4.95496 17.5751 0 11.5 0C5.42486 0 0.5 4.95496 0.5 11.0672C0.5 16.5912 4.52256 21.1697 9.78125 22V14.2663H6.98828V11.0672H9.78125V8.62898C9.78125 5.85525 11.4235 4.32313 13.9361 4.32313C15.1396 4.32313 16.3984 4.53929 16.3984 4.53929V7.26287H15.0114C13.6449 7.26287 13.2188 8.11595 13.2188 8.99117V11.0672H16.2695L15.7818 14.2663H13.2188V22C18.4775 21.1697 22.5 16.5912 22.5 11.0672Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb_logo.e3570777926c59765684f0e3a7e98d9a.svg";
export { ForwardRef as ReactComponent };